module.exports = __webpack_public_path__ + "img/d186621.jpg";